import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import mitt from 'mitt';
import moment from 'moment';
import constant from './utils/constant';
// import mainbodyConfig from 'assets/js/mainbodyConfig.js';
let mainbodyConfig = window.mainbodyConfig;
// delete require.cache[require.resolve(`./utils/mainbodyConfig.js`)];// 每次加载时都不会使用缓存
import request from './utils/request';
import methods from './utils/methods';
import ElementPlus,{ElMessage} from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';//由于在babel.config.js中换成了@babel/preset-env
import 'element-plus/dist/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import previewImage from "@/components/previewImage";
import { traceRootSpan, recordPageLoadDuration } from './utils/otel-config';
import xss from 'xss';

const initStartTime = performance.now();

const app = createApp(App);

// ========== 全局错误捕获（关联 OTel） ==========
app.config.errorHandler = (err, instance, info) => {
	traceRootSpan('vue-global-error', (span) => {
		span.setAttribute('error.instance', instance?.$options?.name || 'unknown');
		span.setAttribute('error.info', info);
		span.setAttribute('error.message', err.message);
		span.setAttribute('error.stack', err.stack);
		console.error('Vue 全局错误,', err, instance, info);
	}).catch(() => {}); // 忽略埋点自身错误
};
app.config.globalProperties.$xss = xss;
app.config.globalProperties.mainbodyConfig = mainbodyConfig;
app.config.globalProperties.process_env_NODE_ENV = process.env.NODE_ENV;
app.config.globalProperties.previewImage = previewImage;//elImage的图片预览在dialog中使用存在bug，重新实现图片预览功能
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
	let _key = key;
	if(key=='Menu')_key = 'iconMenu';
  app.component(_key, component);//全局注册icon组件  <el-icon><Search /></el-icon>
  app.config.globalProperties[_key] = component;  // 支持这类写法<el-button :icon="CirclePlus"/>
}
import localStorage from './utils/localStorage';
let _localStorage = new localStorage('qiuxiao2');
app.config.globalProperties.localStorage = _localStorage;
router.localStorage = _localStorage;

let _mitt = new mitt();
request.$bus = _mitt;
request.mitter = _mitt;
router.$bus = _mitt;
app.config.globalProperties.$bus = _mitt;
app.config.globalProperties.$moment = moment;
app.config.globalProperties.$constant = constant;
app.config.globalProperties.$showElMessage = ElMessage; // 供 App.vue request:error 订阅使用
request.localStorage = _localStorage;
// request.showElMessage 已移除：错误提示改由 $bus.on('request:error') 事件处理，见 App.vue
request.router = router;
request.domain.updateList(mainbodyConfig.api_domians);
try{
	// 如果设置了IP锁定，且是http，且为IP访问，则锁定
	if (typeof window !== 'undefined' 
		&& window.location && window.location.protocol === 'http:' 
		&& window.mainbodyConfig.http_ip_api) {
		const host = window.location.hostname || '';
		if (host == "localhost" || /^\d{1,3}(\.\d{1,3}){3}$/.test(host)) {
			console.warn('锁定http ip访问的域名：', window.mainbodyConfig.http_ip_api);
			request.domain.lock(window.mainbodyConfig.http_ip_api);
		}
	}
} catch (err) {
	console.error('lock domain check error', err);
}
// request.APIURL = mainbodyConfig.api_url;
// if(window.location.protocol == "http:")
// 	request.APIURL = request.APIURL.replace("https:", "http:")
// else if(window.location.protocol == "https:")
// 	request.APIURL = request.APIURL.replace("http:", "https:")

app.config.globalProperties.request = request;
Object.keys(methods).forEach(k=>app.config.globalProperties[k] = methods[k]);//注入方法
import livingIcon from "@/components/customIcon/livingIcon";
import checkBox from "@/components/customIcon/checkBox";
import noData from "@/components/noData";
import customDialog from '@/components/customDialog';
import showLogin from '@/components/layout/showLogin';
app.component('livingIcon',livingIcon);
app.component('checkBox',checkBox);
app.component('noData',noData);
app.component('customDialog',customDialog);
app.component('showLogin',showLogin);

import { createI18n } from 'vue-i18n';
// 语言优先级：本地持久化 > 浏览器语言 > 默认中文
const supportedLanguages = ['zh', 'en', 'vi'];
const storageLanguage = _localStorage.getItem('language');
const browserLanguage = (navigator.language || 'zh').split('-')[0];
let userLanguage = supportedLanguages.includes(storageLanguage)
	? storageLanguage
	: (supportedLanguages.includes(browserLanguage) ? browserLanguage : 'zh');

if(userLanguage=='zh'){
	app.config.globalProperties.$moment.locale('zh-cn');
}else{
	app.config.globalProperties.$moment.locale(userLanguage);
}
// userLanguage = 'en';
let messages = {
	en:require('@/locales/en.json'),
	zh:require('@/locales/zh.json'),
	vi:require('@/locales/vi.json')
}
const i18n = createI18n({
    legacy: false,  // 使用 Composition API
    locale: userLanguage,   // 默认语言
	fallbackLocale: 'en',  // 默认回退语言
    messages
});
// 设置全局错误处理器
// app.config.errorHandler = (err, vm, info) => {
//   // 处理错误，例如发送到后端服务器
//   console.error('捕获到错误:', err);
// };
import socket from './utils/socket.js';
const _socket = new socket({methods, request, mitter:_mitt,mainbodyConfig});
_socket.init();
app.config.globalProperties.$socket = _socket;

// console.log('versionLocal?.version',window.__my_res_ver);
app.config.globalProperties.$WebVersion = window.__my_res_ver;

import unfinished from "@/views/member2/unfinished";
app.component('unfinished',unfinished);



// ========== 追踪应用初始化 ==========
traceRootSpan('vue-app-init', (span) => {
	app.use(router);
	app.use(ElementPlus, {
		locale: zhCn,
	})
	app.use(i18n); // 使用i18n实例
	app.mount('#app')
		.$nextTick(() => {
			const loadDuration = performance.now() - initStartTime;
			// 记录初始页面加载耗时（带标签区分场景）
			recordPageLoadDuration(loadDuration, window.__my_res_ver, window.location.href, 'initial');
		});
});